/* eslint-disable */
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MembersNgApi = void 0;
var json_proto_serializer_1 = require("@wix/json-proto-serializer");
var http_1 = require("@wix/ambassador/runtime/http");
var MembersNgApi = function (baseUrl, httpClientConfig) {
    var httpClient = new http_1.AmbassadorHTTPClient(baseUrl, httpClientConfig);
    return {
        Members: function () {
            return function (headers) {
                var service = {
                    approveMember: function (approveMemberRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('POST', '/v1/members/{id}/approve', approveMemberRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'createdDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'updatedDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'lastLoginDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    blockMember: function (blockMemberRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('POST', '/v1/members/{id}/block', blockMemberRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'createdDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'updatedDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'lastLoginDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    bulkApproveMembers: function (bulkApproveMembersRequest) {
                        return httpClient.invoke('POST', '/v1/members/bulk/approve-by-filter', bulkApproveMembersRequest, headers);
                    },
                    bulkBlockMembers: function (bulkBlockMembersRequest) {
                        return httpClient.invoke('POST', '/v1/members/bulk/block-by-filter', bulkBlockMembersRequest, headers);
                    },
                    bulkDeleteMembers: function (bulkDeleteMembersRequest) {
                        return httpClient.invoke('POST', '/v1/members/bulk/delete-by-filter', bulkDeleteMembersRequest, headers);
                    },
                    createMember: function (createMemberRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var requestTransformations, serializedPayload, response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    requestTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'createdDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'updatedDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'lastLoginDate'] },
                                    ];
                                    serializedPayload = json_proto_serializer_1.batchToJson(createMemberRequest, requestTransformations);
                                    return [4 /*yield*/, httpClient.invoke('POST', '/v1/members', serializedPayload, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'createdDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'updatedDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'lastLoginDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    deleteMember: function (deleteMemberRequest) { return httpClient.invoke('DELETE', '/v1/members/{id}', deleteMemberRequest, headers); },
                    deleteMemberAddresses: function (deleteMemberAddressesRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('DELETE', '/v1/members/{id}/addresses', deleteMemberAddressesRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'createdDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'updatedDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'lastLoginDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    deleteMemberEmails: function (deleteMemberEmailsRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('DELETE', '/v1/members/{id}/emails', deleteMemberEmailsRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'createdDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'updatedDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'lastLoginDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    deleteMemberPhones: function (deleteMemberPhonesRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('DELETE', '/v1/members/{id}/phones', deleteMemberPhonesRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'createdDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'updatedDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'lastLoginDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    deleteMyMember: function (deleteMyMemberRequest) {
                        return httpClient.invoke('DELETE', '/v1/members/my', deleteMyMemberRequest, headers);
                    },
                    disconnectMember: function (disconnectMemberRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('POST', '/v1/members/{id}/disconnect', disconnectMemberRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'createdDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'updatedDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'lastLoginDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    getMember: function (getMemberRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('GET', '/v1/members/{id}', getMemberRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'createdDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'updatedDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'lastLoginDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    getMyMember: function (getMyMemberRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('GET', '/v1/members/my', getMyMemberRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'createdDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'updatedDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'lastLoginDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    joinCommunity: function (joinCommunityRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('POST', '/v1/members/join-community', joinCommunityRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'createdDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'updatedDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'lastLoginDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    leaveCommunity: function (leaveCommunityRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('POST', '/v1/members/leave-community', leaveCommunityRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'createdDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'updatedDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'lastLoginDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    listMembers: function (listMembersRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('GET', '/v1/members', listMembersRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['members', 'createdDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['members', 'updatedDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['members', 'lastLoginDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    muteMember: function (muteMemberRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('POST', '/v1/members/{id}/mute', muteMemberRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'createdDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'updatedDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'lastLoginDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    queryMembers: function (queryMembersRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('POST', '/v1/members/query', queryMembersRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['members', 'createdDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['members', 'updatedDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['members', 'lastLoginDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    unmuteMember: function (unmuteMemberRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('POST', '/v1/members/{id}/unmute', unmuteMemberRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'createdDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'updatedDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'lastLoginDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    updateMember: function (updateMemberRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var requestTransformations, serializedPayload, response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    requestTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'createdDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'updatedDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'lastLoginDate'] },
                                    ];
                                    serializedPayload = json_proto_serializer_1.batchToJson(updateMemberRequest, requestTransformations);
                                    return [4 /*yield*/, httpClient.invoke('PATCH', '/v1/members/{member.id}', serializedPayload, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'createdDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'updatedDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'lastLoginDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    updateMemberSlug: function (updateMemberSlugRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('POST', '/v1/members/{id}/slug', updateMemberSlugRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'createdDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'updatedDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'lastLoginDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    updateMySlug: function (updateMySlugRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('POST', '/v1/members/my/slug', updateMySlugRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'createdDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'updatedDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['member', 'lastLoginDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                };
                service.approveMember.__http_method = 'POST';
                service.approveMember.__http_url = '/v1/members/{id}/approve';
                service.blockMember.__http_method = 'POST';
                service.blockMember.__http_url = '/v1/members/{id}/block';
                service.bulkApproveMembers.__http_method = 'POST';
                service.bulkApproveMembers.__http_url = '/v1/members/bulk/approve-by-filter';
                service.bulkBlockMembers.__http_method = 'POST';
                service.bulkBlockMembers.__http_url = '/v1/members/bulk/block-by-filter';
                service.bulkDeleteMembers.__http_method = 'POST';
                service.bulkDeleteMembers.__http_url = '/v1/members/bulk/delete-by-filter';
                service.createMember.__http_method = 'POST';
                service.createMember.__http_url = '/v1/members';
                service.deleteMember.__http_method = 'DELETE';
                service.deleteMember.__http_url = '/v1/members/{id}';
                service.deleteMemberAddresses.__http_method = 'DELETE';
                service.deleteMemberAddresses.__http_url = '/v1/members/{id}/addresses';
                service.deleteMemberEmails.__http_method = 'DELETE';
                service.deleteMemberEmails.__http_url = '/v1/members/{id}/emails';
                service.deleteMemberPhones.__http_method = 'DELETE';
                service.deleteMemberPhones.__http_url = '/v1/members/{id}/phones';
                service.deleteMyMember.__http_method = 'DELETE';
                service.deleteMyMember.__http_url = '/v1/members/my';
                service.disconnectMember.__http_method = 'POST';
                service.disconnectMember.__http_url = '/v1/members/{id}/disconnect';
                service.getMember.__http_method = 'GET';
                service.getMember.__http_url = '/v1/members/{id}';
                service.getMyMember.__http_method = 'GET';
                service.getMyMember.__http_url = '/v1/members/my';
                service.joinCommunity.__http_method = 'POST';
                service.joinCommunity.__http_url = '/v1/members/join-community';
                service.leaveCommunity.__http_method = 'POST';
                service.leaveCommunity.__http_url = '/v1/members/leave-community';
                service.listMembers.__http_method = 'GET';
                service.listMembers.__http_url = '/v1/members';
                service.muteMember.__http_method = 'POST';
                service.muteMember.__http_url = '/v1/members/{id}/mute';
                service.queryMembers.__http_method = 'POST';
                service.queryMembers.__http_url = '/v1/members/query';
                service.unmuteMember.__http_method = 'POST';
                service.unmuteMember.__http_url = '/v1/members/{id}/unmute';
                service.updateMember.__http_method = 'PATCH';
                service.updateMember.__http_url = '/v1/members/{member.id}';
                service.updateMemberSlug.__http_method = 'POST';
                service.updateMemberSlug.__http_url = '/v1/members/{id}/slug';
                service.updateMySlug.__http_method = 'POST';
                service.updateMySlug.__http_url = '/v1/members/my/slug';
                return service;
            };
        },
    };
};
exports.MembersNgApi = MembersNgApi;
exports.MembersNgApi.__transport = 'http';
__exportStar(require("./types"), exports);
//# sourceMappingURL=http.js.map